import { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import React from 'react';
import { NewsLetterService } from '../../Services/NewsLetterService';
import { IMessage } from '../../Models';

interface INewsLetterListWidgetState {
    newsLetterList: IMessage[];
    isLoading: boolean;
}

interface INewsLetterListWidgetProps {
    area: string;
    dictResult: string;
    dictResults: string;
}

export class NewsLetterListWidget extends Component<
    INewsLetterListWidgetProps,
    INewsLetterListWidgetState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            newsLetterList: [],
            isLoading: true,
        };

        void this.getNewsList();
    }

    async getNewsList() {
        const newsLetterList = await NewsLetterService.getAllMessage(
            this.props.area
        );
        this.setState({ newsLetterList, isLoading: false });
    }

    render() {
        return (
            <>
                {this.state.isLoading && (
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                )}
                {!this.state.isLoading && (
                    <div className="results-topbar">
                        <span className="number-results">
                            {this.state.newsLetterList.length}{' '}
                            {this.state.newsLetterList.length > 1
                                ? this.props.dictResults
                                : this.props.dictResult}
                        </span>
                    </div>
                )}
                {this.state.newsLetterList &&
                    this.state.newsLetterList.map((newsLetter, index) => {
                        return (
                            <div className="tiles" key={index}>
                                <article className="tile">
                                    <div className="tile-content">
                                        <a
                                            href={newsLetter.webLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <h4>{newsLetter.name}</h4>
                                        </a>
                                        <div className="details">
                                            <span>
                                                {newsLetter.creationDate}
                                            </span>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        );
                    })}
            </>
        );
    }
}

WidgetHelper.register(NewsLetterListWidget, 'news-letter-list-widget');
